import { HoldingClass, Share } from 'types';
import { RangeFromByHoldingClass } from '../types/RangeFromByHoldingClass';

export const getShareRangeFromByHoldingClass = (
  holdingClasses: HoldingClass[],
  shares: Share[]
): RangeFromByHoldingClass =>
  holdingClasses?.reduce<RangeFromByHoldingClass>((acc, holdingClass) => {
    const sharesByHoldingClass = shares.filter(
      (share) => share.shareClass?._id === holdingClass._id && share?.isActive
    );

    const sortedShares = sharesByHoldingClass.sort((a, b) => a.from - b.from);

    if (sortedShares.length > 0) {
      const lastShare = sortedShares[sortedShares.length - 1];
      acc[holdingClass._id] = lastShare.to + 1;
    } else {
      acc[holdingClass._id] = 1; // fallback if no shares
    }

    return acc;
  }, {});
